<template>
  <div class="page dashboard banner-dashboard">
    <div class="content">
      <div class="title-bar">
        <p class="title">Top Banners</p>
        <p 
          class="add btn" 
          v-on:click="openNewTopBannerModal"
        >
          Add Top Banner
        </p>
      </div>
      <div class="banner-list">
        <div :key="banner._id" v-for="(banner, index) in topBanners">
          <span style="font-size: 24px; font-weight: bold;">
            {{getBannerTitle(index, banner)}}
          </span>
          <br>
          <span>Order: </span>
          <input type="number" name="order" :id="'order-' + banner._id" placeholder="order" step="1" v-model="banner.order">
          <button type="button" @click="changeOrder(banner._id)">save</button>
          <br>
          <div class="banner-item" :style="{'background-color': banner.bgColor}">
            <img :src="`${API_URL}/${banner.image}`" alt="" class="image">
            <div class="delete-container">
              <p class="btn delete" v-on:click="deleteTopBanner(banner._id)">
                Delete
              </p>
          </div>
          </div>
        </div>
      </div>
    </div>
    <NewTopBannerModal 
      v-if="newTopBannerModalOpened" 
      :closeModal="closeNewTopBannerModal"
    />
  </div>
</template>

<script>
import {API_URL} from '../../const'
import NewTopBannerModal from './NewTopBannerModal'
export default {
  components: {
    NewTopBannerModal
  },
  data() {
    return {
      newTopBannerModalOpened: false
    }
  },
  created() {
    this.getTopBanners()
  },
  methods: {
    getBannerTitle(index, banner) {
      return (index + 1) + '. ' + banner?.product?.name;
    },
    changeOrder(bannerId) {
      const order = document.getElementById('order-' + bannerId).value;
      if(order) {
        this.$store.dispatch('topBannerModule/changeOrder', {bannerId, order})
      }
    },
    openNewTopBannerModal() {
      this.newTopBannerModalOpened = true
    },
    closeNewTopBannerModal() {
      this.newTopBannerModalOpened = false
    },
    getTopBanners() {
      this.$store.dispatch('topBannerModule/getTopBanners')
    },
    deleteTopBanner(_id) {
      const confirmed = confirm('Are you sure you want to delete this?')
      confirmed && this.$store.dispatch('topBannerModule/deleteTopBanner', {_id})
    }
  },
  computed: {
    topBanners() {
      return this.$store.state.topBannerModule.topBanners.data
    },
    API_URL() {
      return API_URL
    }
  }
}
</script>

<style>

</style>